'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchMyItemListQuery } from '@module/queries/item/itemQueryHooks';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import TimeConstants from '@module/utils/item';
function ItemsOnUsing() {
  const $ = _c(10);
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  const bjIdx = playInfo?.media.userIdx || 0;
  const isMyRoom = userInfo?.idx === bjIdx;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      offset: 0,
      limit: 10,
      type: "nowUse"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isMyRoom) {
    t1 = {
      staleTime: TimeConstants.ONE_MINUTE,
      enabled: isMyRoom
    };
    $[1] = isMyRoom;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: itemList
  } = useFetchMyItemListQuery(t0, t1);
  let t2;
  let t3;
  let t4;
  if ($[3] !== itemList?.list) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const filteredItems = itemList?.list.filter(_temp2) || [];
      if (filteredItems.length === 0) {
        t4 = null;
        break bb0;
      }
      t2 = "whitespace-pre-wrap text-[14px] text-cht_al_1";
      t3 = filteredItems.map(_temp3);
    }
    $[3] = itemList?.list;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = <div className={t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp3(item_0) {
  return <div key={item_0.info}>{`[${item_0.info}] 아이템을 사용하셨습니다.`}</div>;
}
function _temp2(item) {
  return item.itemType === "listUp";
}
function _temp(state) {
  return state.data;
}
export default ItemsOnUsing;